import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';

export const useLocalHooks = (userId: string) => {
  const { session } = useTellerSession();

  return {
    isMe: session && session?.tellerUser && session.tellerUser.id === userId,
  };
};
